import { render, staticRenderFns } from "./handout.vue?vue&type=template&id=0bc34102&"
import script from "./handout.vue?vue&type=script&lang=js&"
export * from "./handout.vue?vue&type=script&lang=js&"
import style0 from "./handout.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "handout.vue"
export default component.exports